import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AssetExportConfigurationContext } from '../../../../../../../context/AssetExportConfigurationContext';
import {
  AssetExportConfigurationInput,
  DeleteAssetExportConfigurationInput,
} from '../../../../../../../types/asset_export_configuration';
import DeleteModal from '../../../../../../../VentoryUI/components/common/Modal/DeleteModal';
import { useRequest } from '../../../../../../../requests/common/requestHook';
import { AssetExportConfigurationRequest } from '../../../../../../../requests/assetExportConfiguration.request';
import { translate } from '../../../../../../../types/translation/Translator';
import { TranslationKey } from '../../../../../../../types/translation/TranslationKey';
import { Routing } from '../../../../../../../util/routes.util';

interface DeleteAssetExportConfigurationModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  ids: Set<string>;
}

export default function DeleteAssetExportConfigurationModal({
  open,
  setOpen,
  ids,
}: DeleteAssetExportConfigurationModalProps) {
  const navigate = useNavigate();

  const { assetExportConfigurations, setAssetExportConfigurations } = useContext(AssetExportConfigurationContext);

  const [remove, { loading }] = useRequest(AssetExportConfigurationRequest.remove);

  const handleDelete = async () => {
    const toDelete: DeleteAssetExportConfigurationInput[] = [];

    for (const id of ids) {
      const config = assetExportConfigurations.get(id);
      if (config) toDelete.push(new AssetExportConfigurationInput(config).forDelete());
    }

    const result = await remove({ data: toDelete });
    if (!result) return;

    for (const config of result) {
      assetExportConfigurations.delete(config.id);
    }

    setAssetExportConfigurations(new Map(assetExportConfigurations));
    handleClose();
    navigate(Routing.assets.settings.report.overview());
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <DeleteModal
      text={translate({ key: TranslationKey.assetExportConfigurationDeleteConfirmationText })}
      onConfirm={handleDelete}
      open={open}
      onClose={handleClose}
      loading={loading}
    />
  );
}
